import { roles } from './data'

// Stable ids sent to Graham. Display labels in data.ts can be edited freely; the
// keys must match ROLE_KEYS in graham/services/organizations/workflow_roles.py.
export const roleKeys: Record<string, string> = {
 'APCM coordinator': 'apcm_coordinator',
 'Care-plan reviewing provider': 'careplan_reviewing_provider',
 'Pear super admin': 'pear_super_admin',
 'Physician advisors': 'physician_advisors',
 'Reporting provider': 'reporting_provider',
 'Designated staff contacts': 'designated_staff_contacts',
 'Clinic staff': 'clinic_staff',
 'TCM coordinator': 'tcm_coordinator',
 'Follow-up provider': 'followup_provider',
 'Provider’s MA': 'providers_ma',
 'Billing lead': 'billing_lead',
 'Pear reviewer': 'pear_reviewer',
 'Pear EHR owner': 'pear_ehr_owner',
}

export const roleKey = (label: string) => roleKeys[label]
export const roleLabel = (key: string) => roles.find(([label]) => roleKeys[label] === key)?.[0] ?? key
